// Init

$.ajaxSetup({
  cache: false,
});

API_VERSION = "1.0";
API_URL = "/api/" + API_VERSION + "/";

DATE_FORMAT_ISO_DATE = "YYYY-MM-DD";
DATE_FORMAT_ISO_TIMESTAMP = "YYYY-MM-DDThh:mm:ss";

// log

log = (function () {
  var methods = ["debug", "info", "warn", "error", "profile", "profileEnd"],
    adapter = {};

  _.each(methods, function (_m) {
    adapter[_m] =
      mx2_config.log && window.console
        ? function () {
          console.log.apply(console, arguments);
        }
        : function () { };
  });

  return adapter;
})();

// functions

isset = function (_var) {
  return _var !== undefined;
};

padNumber = function (_number, _length) {
  var str = "" + _number;
  while (str.length < _length) {
    str = "0" + str;
  }

  return str;
};

filter_integer = function (_v, _min, _max, _default) {
  _v = parseInt(_v, 10);
  if (isNaN(_v)) {
    if (_default) _v = _default;
    else _v = 0;
  }
  if (_min && _v < _min) _v = _min;
  if (_max && _v > _max) _v = _max;
  return _v;
};

filter_year = function (_v) {
  var y = new Date().getFullYear();
  return filter_integer(_v, 1900, y + 1, y);
};

round_number = function (_number, _digits) {
  var multiple = Math.pow(10, _digits);
  return Math.round(_number * multiple) / multiple;
};

round_to_fixed = function (_number, _digits) {
  return round_number(_number, _digits).toFixed(_digits);
};

bytesToHuman = function (_size) {
  var mags = ["bytes", "kB", "MB", "GB", "TB"];
  var s = _size;
  for (var j in mags) {
    if (s > 1024) {
      s /= 1024.0;
    } else {
      return round_number(s, 2) + " " + mags[j];
    }
  }
};

add_units_interval = function (_details) {
  var sum = 0;
  _.map(_details, function (_d, i) {
    _d.units_from = sum + 1;
    _d.units_to = sum = sum + _d.units;
  });
  return _details;
};

formatIsrc = function (_isrc) {
  if (!(_isrc == "" || _isrc == null)) {
    if (/[a-z]{2}[a-z0-9]{3}[0-9]{7}/i.test(_isrc)) {
      return (
        _isrc.substr(0, 2) +
        "-" +
        _isrc.substr(2, 3) +
        "-" +
        _isrc.substr(5, 2) +
        "-" +
        _isrc.substr(7, 12)
      ).toUpperCase();
    }
    return _isrc;
  }
  return "";
};

formatIswc = function (_iswc) {
  if (!(_iswc == "" || _iswc == null)) {
    if (/^T-?\d{3}\.?\d{3}\.?\d{3}[-.]?\d/.test(_iswc)) {
      return _iswc.replace(
        /^T-?(\d{3})\.?(\d{3})\.?(\d{3})[-.]?(\d)/,
        "T-$1.$2.$3-$4"
      );
    }
    return _iswc;
  }
  return "";
};

formatPartyId = function (_partyId) {
  if (!(_partyId == "" || _partyId == null)) {
    if (/[a-z]{7}[0-9]{10}[a-z0-9]{1}/i.test(_partyId)) {
      return (
        _partyId.substr(0, 2) +
        "-" +
        _partyId.substr(2, 5) +
        "-" +
        _partyId.substr(7, 10) +
        "-" +
        _partyId.substr(17, 18)
      ).toUpperCase();
    }
    return _partyId;
  }
  return "";
};

filterWebAccount = function (_account) {
  if (_account != "") {
    if (_account.split("/").length > 1) {
      _account = _account.substr(_account.lastIndexOf("/") + 1);
    }
  }
  return _account;
};

filterFacebookField = function (_account) {
  if (_account != "") {
    if (_account.indexOf("pages/") >= 0) {
      _account = _account.substr(_account.lastIndexOf("pages/"));
    } else if (_account.split("/").length > 1) {
      _account = _account.substr(_account.lastIndexOf("/") + 1);
    }
  }
  return _account;
};

filterTwitterField = function (_account) {
  if (_account != "") {
    _account = _account.replace("@", "");

    if (_account.split("/").length > 1) {
      _account = _account.substr(_account.lastIndexOf("/") + 1);
    }
  }
  return _account;
};

filterAppleIdField = function (_account) {
  return _account ? _account.trim().match(/\d+$/) : _account;
};

filterSpotifyIdField = function (_account) {
  return _account ? _account.trim() : _account;
};

getTime = function (nMSec, bAsString) {
  // convert milliseconds to mm:ss, return as object literal or string
  var nSec = Math.floor(nMSec / 1000);
  var min = Math.floor(nSec / 60);
  var sec = nSec - min * 60;
  return bAsString
    ? min + ":" + (sec < 10 ? "0" + sec : sec)
    : { min: min, sec: sec };
};

getSixMonthsAgo = function () {
  var now = new Date();
  now.setMonth(now.getMonth() - 6);
  var month = now.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  var day = now.getDate();
  day = day > 9 ? day : "0" + day;
  return now.getFullYear() + "-" + month + "-" + day;
};

getToday = function () {
  var now = new Date();
  var month = now.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  var day = now.getDate();
  day = day > 9 ? day : "0" + day;
  return now.getFullYear() + "-" + month + "-" + day;
};

isIE = function () {
  return (
    /msie/i.test(navigator.userAgent) && !/opera/i.test(navigator.userAgent)
  );
};

playReleaseAllTracks = function (_albumId) {
  app.player.load();

  $.get("/api/1.0/albums/" + _albumId + "/tracks", function (tracks) {
    var album = [];

    $.each(tracks, function (index) {
      album.push(tracks[index].track);
    });

    app.player.addAlbum(album);
  });
};

// Backbone

(function (_mx2) {
  _mx2.Collection = Backbone.Collection.extend({
    fetch: function (_options) {
      if (_.isArray(_options.ids)) {
        if (_.size(_options.ids) == 0) {
          return false;
        }
        var needed = _.unique(_.difference(_options.ids, this.pluck("id")));
        if (_.size(needed) == 0) {
          return false;
        }
        _options.url = this.url + needed.join(",");
      }
      _options.update = true;
      _options.remove = false;
      return Backbone.Collection.prototype.fetch.call(this, _options);
    },
  });

  _mx2.Albums = _mx2.Collection.extend({ url: "/api/1.0/albums/" });

  _mx2.Releases = _mx2.Collection.extend({ url: "/api/1.0/releases/" });

  _mx2.Channels = _mx2.Collection.extend({ url: "/api/1.0/channels/" });

  _mx2.Tracks = _mx2.Collection.extend({ url: "/api/1.0/tracks/" });

  _mx2.Artists = _mx2.Collection.extend({ url: "/api/1.0/artists/" });
})((window.Mx2 = window.Mx2 || {}));

// API Response

ApiResponse = function (_response, _settings) {
  this.response = _response;
  this.settings = _settings || {};
  if (this.settings.element == undefined) {
    this.settings.element = "p";
  }
};
ApiResponse.prototype = {
  getMsgs: function (_property) {
    return this.getMsg(
      [],
      this.response[_property] ? this.response[_property] : this.response
    );
  },
  getMsg: function (_msgs, _item) {
    if (typeof _item == "array" || typeof _item == "object") {
      for (var i in _item) {
        _msgs = this.getMsg(_msgs, _item[i]);
      }
    } else {
      _msgs.push(_item);
    }
    return _msgs;
  },
  getHumanMsgs: function (_property) {
    var msgs = this.getMsgs(_property);
    var human = "";
    for (var i in msgs) {
      human += this.formatMsg(msgs[i]);
    }
    return human;
  },
  formatMsg: function (_msg) {
    return (
      "<" +
      this.settings.element +
      ">" +
      _msg +
      "</" +
      this.settings.element +
      ">"
    );
  },
};

////////////////////////////////////
// Class: ModelHelper
//////////////////////////////////
ModelHelper = function (model, model_path, module, action) {
  this._model = model;
  this._model_path = model_path;
  this._module = module ? module : null;
  this._action = action ? action : null;
  this._imgAttr = "image";
};
ModelHelper.prototype.shortened = function (attrib, maxlen) {
  var str = this._model[attrib];
  return shortened(str, maxlen);
};
ModelHelper.prototype.linkToEdit = function (_txt, _target, _id) {
  var txt = $("<div/>").text(_txt).html();
  return (
    '<a href="' +
    this.getLocation(_id) +
    '" target="' +
    (_target ? _target : "") +
    '">' +
    txt +
    "</a>"
  );
};
ModelHelper.prototype.htmlForName = function (_default, _target) {
  var name;
  if (!this._model.name) {
    name =
      "<div><b><i>" +
      this.linkToEdit(_default ? _default : _T("Untitled/Unnamed"), _target) +
      "</i></b></div>";
  } else {
    name =
      "<div><b>" + this.linkToEdit(this._model.name, _target) + "</b></div>";
  }
  return name;
};
ModelHelper.prototype.htmlForShortName = function (_default, _target, _id) {
  var name;
  if (!this._model.name) {
    name =
      "<div><b><i>" +
      this.linkToEdit(_default ? _default : _T("Untitled/Unnamed"), _target) +
      "</i></b></div>";
  } else {
    name =
      "<div><b>" +
      this.linkToEdit(shortened(this._model.name, 30), _target, _id) +
      "</b></div>";
  }
  return name;
};
ModelHelper.prototype.htmlForTitleLink = function (
  _default,
  _otherField,
  _target
) {
  var title;
  if (!this._model.title) {
    title =
      "<div><b><i>" +
      this.linkToEdit(_default ? _default : _T("Untitled/Unnamed"), _target) +
      "</i></b></div>";
  } else {
    title =
      "<div><b>" + this.linkToEdit(this._model.title, _target) + "</b></div>";
  }
  if (_otherField) {
    title +=
      "<div>" +
      (this._model[_otherField] ? this._model[_otherField] : "-") +
      "</div>";
  }
  return title;
};

ModelHelper.prototype.htmlSpanWithTextEscaped = function (_text) {
  return $("<span/>").text(this._model[_text] ? this._model[_text] : "-");
};


ModelHelper.prototype.htmlForItemTitleAndArtist = function (_default) {
  var td = $("<td></td>");
  var div = this.htmlForTitleLink(_default);
  var spanDiv = $("<div></div>");
  var span = this.htmlSpanWithTextEscaped("display_artist");

  spanDiv.append(span);
  td.append(div, spanDiv);

  return td;
};

/* IMPERSONATE FUNCTIONS LINK ITEM */

ModelHelper.prototype.linkToEditImpersonate = function (_txt) {
  const txt = $("<div/>").text(_txt).html();
  return `<a href="#" target="" class="impersonate-modal-${this._model.id}" role="button">${txt}</a>`;
};

ModelHelper.prototype.linkToEditImpersonateDistribution = function (_txt, id) {
  const txt = $("<div/>").text(_txt).html();
  return `<a href="#" target="" class="impersonate-modal-${id}" role="button">${txt}</a>`;
};


/* IMPERSONATE FUNCTIONS DISTRIBUTION LIST LINK ITEM */
ModelHelper.prototype.htmlForDistributionTitleLink = function (
  _default,
  _otherField,
  _id
) {

  var title;
  if (!this._model.title) {
    title =
      "<div><b><i>" +
      this.linkToEditImpersonateDistribution(_default ? _default : _T("Untitled/Unnamed"), _id) +
      "</i></b></div>";
  } else {
    title =
      "<div><b>" + this.linkToEditImpersonateDistribution(this._model.title, _id) + "</b></div>";
  }

  if (_otherField) {
    title +=
      "<div>" +
      (this._model[_otherField] ? this._model[_otherField] : "-") +
      "</div>";
  }
  return title;
};

/* IMPERSONATE FUNCTIONS RELEASE LIST ITEM*/

ModelHelper.prototype.htmlForTitleImpersonate = function () {
  return `<div><b> ${this._model.title ? this.linkToEditImpersonate(this._model.title) : `<i>${this.linkToEditImpersonate(_T('untitled album'))}</i>`}</b></div>`
};

ModelHelper.prototype.htmlForReleasesListItemTitleImpersonate = function () {

  const td = $("<td></td>");
  const div = this.htmlForTitleImpersonate();
  const spanDiv = $("<div></div>");
  const span = this.htmlSpanWithTextEscaped("display_artist");

  spanDiv.append(span);
  td.append(div, spanDiv);

  return td;
};
/* ---- */

/* IMPERSONATE FUNCTIONS ARTISTS LIST ITEM*/
ModelHelper.prototype.htmlForNameImpersonate = function () {
  return `<div><b> ${this._model.name ? this.linkToEditImpersonate(this._model.name) : `<i>${this.linkToEditImpersonate(_T('artist with no name'))}</i>`}</b></div>`
};
/* ---- */


ModelHelper.prototype.htmlForTitle = function (_default, _otherField) {
  var title;
  if (!this._model.title) {
    title =
      "<div><b><i>" +
      (_default ? _default : _T("Untitled/Unnamed")) +
      "</i></b></div>";
  } else {
    title = "<div><b>" + this._model.title + "</b></div>";
  }
  if (_otherField) {
    title +=
      "<div>" +
      (this._model[_otherField] ? this._model[_otherField] : "-") +
      "</div>";
  }
  return title;
};
ModelHelper.prototype.htmlForShortTitle = function (
  _default,
  _otherField,
  _target
) {
  var title;
  if (!this._model.title) {
    title =
      "<i>" +
      this.linkToEdit(_default ? _default : _T("Untitled/Unnamed"), _target) +
      "</i>";
  } else {
    title = this.linkToEdit(txt2column(this._model.title, 20, 1), _target);
  }
  var title = '<div class="short_title"><b>' + title + "</b></div>";
  if (_otherField) {
    title +=
      '<div class="short_subtitle">' +
      (this._model[_otherField]
        ? txt2column(this._model[_otherField], 24, 2)
        : "") +
      "</div>";
  }
  return title;
};
ModelHelper.prototype.withImgAttr = function (attr) {
  this._imgAttr = attr;
  return this;
};
/**
 * @param attr The name of the image attr in the model.
 * @param size One of: 'original', 'full', '350', '150' or '40'.
 * @param cssClass Extra style classes that will be added to the returned div.
 */
ModelHelper.prototype.getImage = function (attr, size, cssClass, id) {
  var src = "";
  if (_.isArray(size)) {
    var ratio = size[1];
    size = size[0];
  }

  var model = this._model;
  var attribute = attr;
  if (_.isArray(attr)) {
    model = this._model[attr[0]];
    attribute = attr[1];
  }

  if (typeof model !== "undefined") {
    if (
      typeof model[attribute] == "object" &&
      model[attribute][size] &&
      model[attribute][size].href
    ) {
      src = model[attribute][size].href;
    }
  } else {
    src = "";
  }

  if (typeof cssClass == "undefined") cssClass = "";
  switch (size) {
    case "original":
      cssClass += " medium";
      break;
    case "full":
      cssClass += " medium";
      break;
    case "40":
      cssClass += " small";
      break;
    case "150":
      cssClass += " medium";
      break;
    case "350":
      cssClass += " large";
      break;
    default:
      break;
  }
  if (ratio) {
    cssClass += "_" + ratio;
  }

  return createImgDiv({
    className: cssClass,
    link: this.getLocation(id),
    src: src,
  });
};

ModelHelper.prototype.getLocation = function (id) {
  var location = "";
  if (typeof this._model !== "undefined") {
    var model_id = id ? id : this._model.id;
    location = "/" + this._model_path + "/" + model_id;
    if (this._module != null) location = "/" + this._module + location;
    if (this._action != null) location = location + "/" + this._action;
  }
  return location;
};
ModelHelper.prototype.getApiLocation = function () {
  return API_URL + this._model_path + "/" + this._model.id;
};
ModelHelper.prototype.activeIconForField = function (field) {
  if (field == null || field == "undefined") field = "active";

  var fieldValue = this._model[field];
  var cssClass = "active-entry";
  if (fieldValue == 0) cssClass = "inactive-entry";
  var div = $("<div></div>").addClass("icon " + cssClass);
  return div;
};
ModelHelper.prototype.deleter = function (pager, confirmMsg) {
  if (confirmMsg == "undefined") confirmMsg = null;

  var options = {
    url: this.getApiLocation(),
    pager: pager,
  };
  if (confirmMsg != null) options.confirm_msg = confirmMsg;
  var deleter = new DeletePagerEntry(options);
  return deleter;
};
ModelHelper.prototype.deleterIcon = function (pager, confirmMsg) {
  return this.deleter(pager, confirmMsg).a;
};
ModelHelper.prototype.getModelIcon = function (style) {
  var cssClass = "icon model-icon model-" + this._model_path;
  var div = $("<div></div>").addClass(cssClass);

  if (style) {
    div.css(style);
  }

  return div;
};

/**
 * @param params {className:, link:, src:}
 */
createImgDiv = function (params) {
  var div = $("<div></div>");
  var options = {
    element: div,
  };
  if (params["className"]) options["className"] = params["className"];
  if (params["link"]) options["link"] = params["link"];
  if (params["src"]) options["src"] = params["src"];
  new ImageBox(options);
  return div;
};
shortened = function (str, maxlen) {
  if (typeof maxlen == "undefined") {
    maxlen = 150;
  }
  if (str.length < maxlen) return str;

  str = str.substr(0, maxlen - 3) + "...";
  return str;
};
txt2column = function (txt, maxlen, LINES) {
  if (typeof maxlen == "undefined") {
    maxlen = 24;
  }
  if (typeof LINES == "undefined") {
    LINES = 2;
  }

  var totalLen = maxlen * LINES;

  var tokens = txt.split(" ");
  var numTokens = tokens.length;
  var numLines = 0;
  var lastIndex = numTokens - 1;
  var col = "";
  var line = tokens[0];
  if (line.length > maxlen) line = line.substr(0, maxlen - 3) + "...";
  if (numTokens > 1) line += " ";
  for (var i = 1; i < numTokens && numLines < LINES; i++) {
    var token = tokens[i];
    if (line.length + token.length > maxlen) {
      if (numLines + 1 < LINES) {
        col += line + "<br />";
      } else {
        if (line.length > maxlen) line = line.substr(0, maxlen - 3);
        col += line + "...";
      }
      line = "";
      numLines++;
    }
    if (i < lastIndex) token += " ";
    line += token;
  }
  if (numLines == 0) {
    col += line;
  }
  while (col.length > totalLen && col.lastIndexOf(" ") > 0) {
    col = col.substring(0, col.lastIndexOf(" ")) + "...";
  }
  if (col.length > totalLen && col.lastIndexOf(" ") > 0) {
    col = col.substr(0, totalLen - 3) + "...";
  }
  return col;
};

// Deleter Pager Entry

DeletePagerEntry = function (_settings) {
  this.create(_settings || {});
};
DeletePagerEntry.prototype = {
  create: function (_settings) {
    this.settings = _settings;

    var self = this;

    this.a = $("<a></a>")
      .attr("href", "#")
      .attr("title", "delete")
      .addClass("icon delete")
      .bind("click", function (_data) {
        if (
          _settings.confirm_msg != null &&
          _settings.confirm_msg != "undefined"
        ) {
          if (!confirm(_settings.confirm_msg)) return false;
        }
        var pager = self.settings.pager;
        start_spin();

        $.ajax(self.settings.url, { type: "DELETE" })
          .done(function () {
            pager.page();
          })
          .fail(function (_request, _error) {
            if (_request.responseText) {
              alert(_request.responseText);
            } else {
              alert(_T("Cannot perform this action"));
            }
          })
          .always(function () {
            end_spin();
          });

        return false;
      });
  },
};

// Pager Entry Activator
/**
 * The settings param should contain a 'type' key with 'activator'/'deactivator'
 * values.
 */
PagerEntryActivator = function (_settings) {
  this.create(_settings || {});
};
PagerEntryActivator.prototype = {
  create: function (_settings) {
    this.settings = _settings;

    var self = this;
    this.a = $("<a></a>")
      .attr("href", "#")
      .attr(
        "title",
        this.settings.activates ? _T("activate") : _T("deactivate")
      )
      .text(this.settings.activates ? this.settings.on : this.settings.off)
      .addClass(
        this.settings.off == null && this.settings.on == null
          ? "icon " +
          (this.settings.activates ? "active-entry" : "inactive-entry")
          : ""
      )
      .bind("click", function () {
        $.post(
          self.settings.field
            ? self.settings.url + "/" + self.settings.field
            : self.settings.url,
          JSON.stringify(self.settings.activates ? true : false)
        )
          .done(function () {
            self.settings.pager.page();
          })
          .fail(function (_request, _error) {
            log.error("PagerEntryActivator: " + _request.responseText);
          });
        return false;
      });
  },
};

/**
 * Formats amounts to 2 decimal scale.
 * If a global currency variable exists it is added at the end.
 */
famount = function (_amount, _unit) {
  var num = round_number(_amount, 2).toFixed(2);
  num = _unit ? num + _unit : num;
  return _amount < 0
    ? (num = '<span class="negative">' + num + "</span>")
    : num;
};

// Legacy Form
LegacyForm = (function () {
  var _elements = {
    url: "",
    $form: null,
    errorClass: "",
    doneAction: function () { },
  };

  function _enableForm() {
    _elements.$form.removeClass("hide");
  }

  function _doSubmit() {
    _elements.$form.find("[data-error]").remove();

    $.post(_elements.url, _elements.$form.serialize())
      .done(function (response) {
        _elements.doneAction(response);
      })
      .fail(function (error) {
        _setErrors(JSON.parse(error.responseText));
      });
  }

  function _setErrors(errors) {
    for (var key in errors) {
      var $item = _elements.$form.find('[data-field="' + key + '"]');
      var $tr = $("<tr>").html("<td></td><td></td>").insertAfter($item);
      var $ul = $("<ul>").addClass("errors").appendTo($tr.find("td").last());

      for (var i = 0, len = errors[key].length; i < len; i++) {
        $("<li data-error>")
          .addClass(_elements.errorClass)
          .text(errors[key][i])
          .appendTo($ul);
      }
    }
  }

  function init(params) {
    _elements.url = params.url;
    _elements.$form = params.$form;
    _elements.errorClass = params.errorClass;
    _elements.doneAction = params.doneAction;

    _enableForm();

    _elements.$form.on("submit", function (e) {
      e.preventDefault();
      _doSubmit();
    });
  }

  return {
    init: init,
  };
})();
